import React from 'react'
import PropTypes from 'prop-types'
import { StyledPageContainer } from '../Approvals/Approvals.styles'
import WipReportAiView from './WipReportAiView'

const WipReportAiPage = ({
  person,
  client,
  projects = [],
  selectedProject,
  onProjectSelect,
  invoiceTotals = [],
}) => (
  <StyledPageContainer>
    <WipReportAiView
      person={person}
      client={client}
      projects={projects}
      selectedProject={selectedProject}
      onProjectSelect={onProjectSelect}
      invoiceTotals={invoiceTotals}
    />
  </StyledPageContainer>
)

WipReportAiPage.propTypes = {
  person: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  projects: PropTypes.arrayOf(PropTypes.object),
  selectedProject: PropTypes.object,
  onProjectSelect: PropTypes.func.isRequired,
  invoiceTotals: PropTypes.arrayOf(PropTypes.object),
}

export default WipReportAiPage
